import { useMutation } from "react-query";
import { updatePatient } from "@/services/patient";
/** Mutation hook for updating a patient record. */
export function useUpdatePatient(patientUid) {
  return useMutation(function (payload) {
    return updatePatient(patientUid, payload);
  });
}